export enum enumDLIClassification {
  'Client' = 1,
  'Administrator',
  'Supervisor',
  'Owner',
}

export namespace enumDLIClassification {
  export function values() {
    return Object.keys(enumDLIClassification).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
